export enum UseCases {
    Starter = 'starter',
    Databases = 'databases',
    Ai = 'ai',
    Messaging = 'messaging',
    Utilities = 'utilities',
    Devtools = 'dev-tools',
    Auth = 'auth',
}